module.exports = __webpack_public_path__ + "media/images/athletes/3586-e5a48106b853584f2beb6d35184279a7.png";